export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const imgVisbility = require("../assets/visibility.svg");
export const imgVisbilityOff = require("../assets/visibilityOff.svg");
export const calendarIcon = require("../assets/calendar_icon.png");
export const phoneIcon = require("../assets/phone_icon.svg");
export const regionIcon = require("../assets/region_icon.svg");
export const deleteIcon = require("../assets/delete_icon.svg");
export const warningIcon = require("../assets/warning_icon.svg");